import { Component } from "react";
class LoadingV2 extends Component {
  render() {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100vh",
          display: `${this.props.isLoading ? "flex" : "none"}`,
          alignItems: "center",
          justifyContent: "center",
          background: "rgb(0, 0, 0,0.6)",
          zIndex: "1200",
        }}
      >
        <img
          style={{
            width: "60px",
            height: "60px",
          }}
          src="\images\loadingv2.gif"
          alt=""
        />
      </div>
    );
  }
}
export default LoadingV2;
